<template>
  <div class="verval">
    <v-card flat>
      <v-card-text class="pa-0">
        <base-table-header
          outlined-button
          :btn-filter="false"
          :btn-reload="false"
          :search-input="false"
          v-if="list && list.length"
          :options="{ header: true }"
          @reload="onReload"
          @search="onSearch"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah {{ endpoint === 'fetch' ? 'Peserta' : 'Guru' }}
              <span class="blue--text font-weight-medium">{{ list.length }}</span>
            </div>
          </template>
          <template v-slot:toolbarAfter>
            <v-btn v-if="endpoint === 'fetch'" color="success" class="ml-2 text-capitalize" @click="onSetPeserta">
              <v-icon left dark>
                mdi-pencil
              </v-icon>
              Ganti Peserta
            </v-btn>
          </template>
        </base-table-header>
        <v-divider v-if="list && list.length" />
        <base-list-table :hideHeader="true" :loading="loading" :item="list" :total="list.length" :usePaging="false">
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-avatar color="blue">
                  <v-icon dark>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" md="5">
                      <div class="caption grey--text text-lighten-1">
                        Informasi Akun
                      </div>
                      <div class="body-1 mb-0">
                        <span class="blue--text">
                          {{ $getDeepObj(item, 'ptk.nama') || item.nama || '-' }}
                        </span>
                      </div>
                      <div class="body-2">
                        SIMPKB ID:
                        <strong>{{ $getDeepObj(item, 'no_ukg') || $getDeepObj(item, 'ptk.ptk_id') || '-' }}</strong>
                      </div>
                      <div class="body-2">
                        NIP:
                        <strong>
                          {{ $getDeepObj(item, 'ptk.nip') || $getDeepObj(item, 'ptk_info_dapodik.nip') || '-' }}
                        </strong>
                      </div>
                      <div class="body-2">
                        NIK:
                        <strong>
                          {{ $getDeepObj(item, 'ptk.nik') || $getDeepObj(item, 'ptk_info_dapodik.nik') || '-' }}
                        </strong>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="caption grey--text text-lighten-1">
                        Tempat Lahir
                      </div>
                      <div class="body-2 mb-0">
                        {{ $getDeepObj(item, 'tmp_lahir') || '-' }}
                      </div>
                      <div class="caption grey--text text-lighten-1">
                        Tanggal Lahir
                      </div>
                      <div class="body-2 mb-0">
                        {{ $localDate($getDeepObj(item, 'tgl_lahir')) }}
                      </div>
                      <div class="caption grey--text text-lighten-1">
                        Usia
                      </div>
                      <div class="body-2 mb-0">
                        {{ $getDeepObj(item, 'tgl_lahir') ? $getAge($getDeepObj(item, 'tgl_lahir')) : '-' }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="caption grey--text text-lighten-1">
                        Status
                      </div>
                      <div class="body-2 mb-0">
                        {{ item.is_kasek ? 'Kepala Sekolah' : 'Guru' }}
                      </div>
                      <template v-if="!item.is_kasek">
                        <div class="caption grey--text text-lighten-1">
                          Mapel Diampu
                        </div>
                        <div class="body-2 mb-0">
                          {{ item.mapel_ajar }}
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
          <template v-slot:nodata>
            <div v-if="endpoint === 'fetch'" class="text-center grey--text py-5 white">
              <v-icon x-large color="orange">mdi-alert-outline</v-icon>
              <p class="black--text body-2">
                Anda belum memilih Guru yang akan menjadi Peserta Pelatihan Pengimbasan,<br />
                <span v-if="!$getDeepObj(pelatihanAjuan, 'tutup')">
                  silakan melakukan pemilihan peserta melalui tombol berikut
                </span>
                <span v-else>
                  pemilihan data peserta dapat dilakukan pada tanggal
                  <strong>
                    {{ $durasi($getDeepObj(meta, 'config.wkt_mulai'), $getDeepObj(meta, 'config.wkt_selesai')) }}
                  </strong>
                </span>
              </p>
              <v-btn color="success" class="text-capitalize" @click="onSetPeserta">
                <v-icon left>
                  mdi-pencil
                </v-icon>
                Pilih Peserta
              </v-btn>
            </div>
          </template>
        </base-list-table>
      </v-card-text>
    </v-card>
    <base-modal-full
      ref="modal"
      title="Formulir Peserta Pelatihan Pengimbasan"
      :auto-close="false"
      @close="onClose"
      @save="onSave"
    >
      <form-ajuan
        ref="formulir"
        :ajuan="$getDeepObj(pelatihanAjuan, 'ajuan') || {}"
        :kandidats="formulir.kandidats || []"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import FormAjuan from './Formulir';

export default {
  components: { FormAjuan },
  mixins: [list],
  props: {
    endpoint: {
      type: String,
      default: '',
    },
    meta: {
      type: Object,
      default: () => {},
    },
    pengimbasan: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    kandidats: {
      type: Array,
      default: () => [],
    },
    pelatihanAjuan: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  methods: {
    ...mapActions('pengimbasan', ['candidate', 'save']),

    async onSetPeserta() {
      if (this.pelatihanAjuan.tutup) {
        this.$error(this.pelatihanAjuan);
        return;
      }

      const pspPelatihanAjuan = this.pelatihanAjuan.ajuan || {};
      const kandidats = await this.candidate({ id: this.pengimbasan.psp_pelatihan_ajuan_id });
      const pesertas = this.$getDeepObj(this.pelatihanAjuan, 'ajuan.psp_pelatihan_kandidats') || [];
      const pesertasGuru = pesertas
        .filter((peserta) => peserta.ptk_id !== pspPelatihanAjuan.ptk_id)
        .map((peserta) => peserta.ptk_id);
      const kandidatsGuru = kandidats.filter((kandidat) => kandidat.ptk_id !== pspPelatihanAjuan.ptk_id);

      this.$set(this.formulir, 'kandidats', kandidatsGuru);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset(pesertasGuru);
      });
    },

    onClose() {
      this.$refs.modal.loading = false;
    },

    onSave() {
      const message = [
        '<div class="black--text">',
        '<div class="body-1 mb-4 mt-2 font-weight-medium">Informasi Pengingat Sebelum Submit/Simpan Data Calon Peserta Pelatihan</div>',
        '<p>Pastikan Bapak/Ibu sudah melakukan pengisian ajuan peserta Pelatihan Pengimbasan Pelaksana PSP Angkatan I dan data yang sudah diajukan sesuai dengan kriteria yang telah ditentukan.</p>',
        '<p>Salam,</p>',
        '<p><strong>Tim Pelatihan Program Sekolah Penggerak</strong><br /><span class="blue--text">#Sekolah Penggerak</span><br /><span class="blue--text">#Merdeka Belajar</span></p>',
        '</div>',
      ].join('');
      this.$confirm(message, `Konfirmasi Simpan Data`, {
        tipe: 'orange darken-1 white--text',
        lblConfirmColor: 'orange',
        lblConfirmButton: 'Simpan',
        typeConfirmBgButton: true,
        lblCancelButton: 'Batal',
        useReject: true,
      }).then(
        () => {
          const values = this.$refs.formulir.getValue();

          if (!values.length) {
            this.$error('Silahkan pilih peserta pelatihan terlebih dahulu');
            this.$refs.modal.loading = false;
            return;
          }

          this.save({ id: this.pengimbasan.psp_pelatihan_ajuan_id, params: { kandidat: values } })
            .then(() => {
              this.$success('Berhasil disimpan');
              this.$refs.modal.dialog = false;
              this.$emit('reload');
            })
            .catch(() => {
              this.$refs.modal.loading = false;
            });
        },
        () => {
          this.$refs.modal.loading = false;
        }
      );
    },
  },
};
</script>
<style>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
